export { default as TerritoryAuthorityProblemType } from './territoryAuthorityProblemType'
export { default as TerritoryAuthority } from './territoryAuthority';
export { default as Territory } from './territory';